<template>
	<!-- 监理周报 -->
	<div class="mod-config">
			<el-col :span="24" style="margin-top:-10px">
				<el-card body-style="padding-bottom: 0;" style="margin-top: 5px;">
					<el-row class="title_color">
						<el-col :span="20">
							<div class="title">监理周报</div>
						</el-col>
						<el-col :span="4" style="margin-top:10px;margin-bottom:-10px">
							<i class="el-icon-sort" id="PointerIcon" style="right:1rem;transform:rotate(90deg);" @click="goBack()"></i>
							<el-button v-preventReClick type="text" @click="goBack()" class="backbtn">返回门户</el-button>
						</el-col>
					</el-row>
				</el-card>
				<div>
					<el-card style="margin-top: -3px;" body-style="padding: 0;">
						<el-row style="margin-bottom: 10px;">
							<el-col :span="24">
								<div>
									<el-table :height="screenHeight - 110 + 'px'" :row-class-name="tableRowClassName" class="dataListTable" border
										:data="dataList" header-align="center" style="width: 100%; margin-bottom: 20px;"
										header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
										<el-table-column type="index" label="NO." width="60" align="center">
											<template slot-scope="scope">{{ (pageIndex2 - 1) * limit + scope.$index + 1
											}}</template>
										</el-table-column>
										<el-table-column prop="weeklyName" label="周报编号" min-width="200" align="center">
											<template slot-scope="scope">
												<el-button v-preventReClick type="text" size="small"
													@click="viewPdf(scope.row.finalFilePath, scope.row.weeklyName)">{{
														scope.row.weeklyName}}</el-button>
											</template>
										</el-table-column>
										<el-table-column label="日期" min-width="200" align="center">
											<template slot-scope="scope">
												{{ scope.row.beginTime }} ~~ {{ scope.row.endTime }}
											</template>
										</el-table-column>
										<el-table-column prop="insDate" label="制作日期" min-width="160" align="center">
										</el-table-column>
										<el-table-column label="操作" width="80" fixed="right" align="center">
											<template slot-scope="scope">
												<el-button v-preventReClick type="text" size="small"
													@click="downloadHandle(scope.row.recNo)">附件查看</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
								<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
									@current-change="currentChangeHandle" :current-page="page" :page-sizes="[10, 20, 50, 100]"
									:page-size="limit" :total="totalCount" layout="total, sizes, prev, pager, next, jumper">
								</el-pagination>
							</el-col>
						</el-row>
					</el-card>
				</div>
			</el-col>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		<!-- <weekly-report-upload v-if="reportUploadVisible" ref="weeklyReportUpload"
			@refreshDataList="getDataList"></weekly-report-upload> -->
		<weekly-export v-if="exportVisible" ref="weeklyExport" @refreshDataList="getDataList"></weekly-export>
		<audit v-if="auditVisible" ref="audit" @refreshDataList="getDataList"></audit>
		<weekly-file-upload v-if="fileUploadVisible" ref="weeklyFileUpload"
			@refreshDataList="getDataList"></weekly-file-upload>
		<enclosure-add-or-update v-if="enclosureVisible" ref="enclosureAddOrUpdate"
			@refreshDataList="getDataList"></enclosure-add-or-update>
		<weekly-report-download v-if="downloadVisible" ref="weeklyReportDownload"
			@refreshDataList="getDataList"></weekly-report-download>
		<weekly-report-file-upload v-if="reportFileUploadVisible" ref="weeklyReportFileUpload"
			@refreshDataList="getDataList"></weekly-report-file-upload>
		<weekly-refirm v-if="refirmVisible" ref="weeklyRefirm" @refreshDataList="getDataList"></weekly-refirm>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</div>
</template>
<script>
import AddOrUpdate from './weekly-add-or-update'
import WeeklyExport from './weekly-export'
import EnclosureAddOrUpdate from './enclosure-list'
import $common from "@/utils/common.js"
import audit from './weekly-audit'
import WeeklyFileUpload from "./weekly-file-upload";
import WeeklyReportUpload from "./weekly-report-upload"
import WeeklyReportDownload from "./weekly-report-download.vue"
import WeeklyReportFileUpload from "./weekly-report-file-upload.vue"
import WeeklyRefirm from "./weekly_refirm"
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			showSearch: false,
			showDownload: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			showCheck: false,
			action: '',
			showArchive: false,
			showRowDownload: false,
			pageSpan: 12,
			refirmVisible: false,
			addOrUpdateVisible: false,
			fileUploadVisible: false,
			exportVisible: false,
			auditVisible: false,
			enclosureVisible: false,
			reportUploadVisible: false,
			downloadVisible: false,
			reportFileUploadVisible: false,
			form: {},
			limit: 20,
			page: 1,
			totalCount: 0,
			dataList: [],
			tableSelVal: [],
			// 显示序号
			pageIndex2: 1,
			screenHeight: 0,
		};
	},
	components: {
		WeeklyReportFileUpload,
		WeeklyReportDownload,
		// WeeklyReportUpload,
		WeeklyFileUpload,
		AddOrUpdate,
		audit,
		WeeklyExport,
		EnclosureAddOrUpdate,
		WeeklyRefirm,
		ViewPdf
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.showSearch = $common.isAuth('weekly:search');
		this.showDownload = $common.isAuth('weekly:download');
		this.showAdd = $common.isAuth('weekly:add');
		this.showEdit = $common.isAuth('weekly:edit');
		this.showDelete = $common.isAuth('weekly:delete');
		this.showCheck = $common.isAuth('weekly:check');
		this.showArchive = $common.isAuth('weekly:archive');
		this.showRowDownload = $common.isAuth('weekly:download');
		if (!this.showSearch && !this.showDownload && !this.showAdd) {
			this.pageSpan = 24;
		}
		this.getDataList();
	},
	methods: {
		uploadFileHandle(id, weeklyName) {
			this.fileUploadVisible = true
			this.$nextTick(() => {
				this.$refs.weeklyFileUpload.init(id, weeklyName)
			})
		},
		enclosureHandle(id) {
			this.enclosureVisible = true
			this.$nextTick(() => {
				this.$refs.enclosureAddOrUpdate.init(id)
			})
		},
		selectFile(url) {
			window.open(url);
		},
		downloadPic(id) {
			this.$http({
				url: this.$store.state.httpUrl + "/business/fileinfo/downloadWeekZip",
				method: 'get',
				params: this.$http.adornParams({
					recNo: id
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					window.open(data.body);
				} else {
					this.$message.error(data.msg)
				}
			})
		},
		weeklyReportUpload() {
			this.reportUploadVisible = true;
			this.$nextTick(() => {
				this.$refs.weeklyReportUpload.init()
			})
		},
		fileUploadHandle(id) {
			this.reportFileUploadVisible = true
			this.$nextTick(() => {
				this.$refs.weeklyReportFileUpload.init(id)
			})
		},
		refirmHandle(id) {
			this.refirmVisible = true
			this.$nextTick(() => {
				this.$refs.weeklyRefirm.init(id)
			})
		},
		cancelRefirmHandle(id) {
			this.$confirm(`确定对选中的数据进行解除确认操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportinfo/cancelWeeklyRefirm/" + id,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		downloadHandle(id) {
			this.downloadVisible = true;
			this.$nextTick(() => {
				this.$refs.weeklyReportDownload.init(id)
			})
		},
		//重置
		resetFormData() {
			this.pageIndex = 1;
			this.getDataList();
		},
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportinfo/list",
				method: 'get',
				params: this.$http.adornParams({
					limit: this.limit,
					page: this.page,
					subjectNo: $common.getItem("subjectNo"),
					workNo: $common.getItem("workNo"),
					refirmFlg: '1'
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataList = data.body.records;
					this.totalCount = data.body.totalCount;
					this.pageIndex2 = this.page
				} else {
					this.dataList = []
					this.totalCount = 0
					this.pageIndex2 = 1
				}
			})
		},
		// 审核
		auditeHandle(id) {
			this.auditVisible = true
			this.$nextTick(() => {
				this.$refs.audit.init(id)
			})
		},
		cancelAuditeHandle(id) {
			this.$confirm(`确定对选中的数据进行撤销审核生成周报吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportinfo/restoreCheckWeekly?recNo=" + id,
					method: "POST",
					data: {},
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			})
		},
		cancelHandle(id) {
			this.$confirm(`确定对选中的数据进行还原生成周报吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportinfo/restoreWeekly?recNo=" + id,
					method: "POST",
					data: {},
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			})
		},
		createHandle(id) {
			this.$confirm(`确定对选中的数据进行生成周报吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/fileinfo/downloadWeek?recNo=" + id,
					method: "POST",
					data: {},
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		//删除
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportinfo/delete/" + id,
					method: "get",
					data: {},
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			})
		},
		viewPdf(filePath, filename) {
			// $common.viewFile(filePath)
			if(filePath == null || filePath == undefined || filePath == '') {
				this.$message.error("没有可预览的文件！");
				return;
			} 
			this.viewPdfVisible = true;
			this.$nextTick(() => {
				this.$refs.viewPdf.init(filename, filePath)
			})
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 190;
			return { height: height + 'px' }
		},
		handleSelectionChange(val) {
			// console.log(val)
			this.tableSelVal = val;
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		archiveFile(id) {
			this.$confirm(`确定对选中的发文进行归档操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportinfo/archiveFile/" + id,
					method: "get",
					data: id,
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error("归档设置失败")
					}
				});
			});
		},
		removeArchiveFile(id) {
			this.$confirm(`确定对选中的发文进行取消归档操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportinfo/removeArchiveFile/" + id,
					method: "get",
					data: id,
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error("取消归档失败")
					}
				});
			});
		},
		// 每页数
		sizeChangeHandle(val) {
			this.limit = val
			this.page = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.page = val
			this.getDataList()
		},
		addOrUpdateHandle(id) {
			// this.$router.push({name:'weeklyExportInfo',params:{recNo:id,editFlag:"1"}});
			this.addOrUpdateVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id);
			})
		},
		editHandle(id, reportKind, weeklyStatus) {
			if (reportKind === '2') {
				this.$router.push({ name: 'weeklyDeviceExportInfo', query: { recNo: id } });
			} else {
				if (weeklyStatus === "0") {
					this.refreshEnclosureFiles(id)
				} else {
					this.refreshAllDataList(id)
				}
			}
		},
		exportHandle() {
			this.exportVisible = true
			this.$nextTick(() => {
				this.$refs.weeklyExport.init()
			})
		},
		refreshEnclosureFiles(id) {
			let _url = "/business/weeklyreportinfo/refreshEnclosureFiles/" + id;
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: []
			}).then(({ data }) => {
				if (data && data.code === 200) {
					// 跳转
					this.$router.push({ name: 'weeklyExportInfo', query: { recNo: id } });
				}
			});
		},
		refreshAllDataList(id) {
			let _url = "/business/weeklyreportinfo/refreshAllDataList/" + id;
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: []
			}).then(({ data }) => {
				if (data && data.code === 200) {
					// 跳转
					this.$router.push({ name: 'weeklyExportInfo', query: { recNo: id } });
				}
			});
		},
		goBack() {
			this.$router.push({ name: 'workbench' });
		}
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.my-pagination {
	margin-left: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

.title_color {
	height: 60px !important;
}
</style>
